const features = [
  {
    icon: 'ri-volume-up-fill',
    title: '有声体验',
    desc: '为每部作品配好情绪化的音效与配乐，画面与声音同步律动，让追更体验像看一部会呼吸的故事。',
  },
  {
    icon: 'ri-palette-fill',
    title: '全彩呈现',
    desc: '高饱和全彩上色，人物与场景层次分明，每一格都经得起放大细看，沉浸感直接拉满。',
  },
  {
    icon: 'ri-bard-fill',
    title: '特效拉满',
    desc: '镜头推拉、光影流转、粒子与速度线特效叠加，让分镜真正动起来，燃点场面更具冲击力。',
  },
  {
    icon: 'ri-mic-fill',
    title: '配音同步',
    desc: '热门作品配音版同步更新，声优情感投入到位，一集不落，耳朵和眼睛一起过瘾。',
  },
];

export default function Features() {
  return (
    <section id="features" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-medium tracking-widest text-primary-400">WHY HANMOTION</span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-50 md:text-4xl">为什么都在这里看动态漫画</h2>
          <p className="mt-4 text-sm leading-7 text-foreground-300">
            我们把"好看"拆解成看得见的细节：有声、全彩、特效、配音，四重体验叠加，只为给你最流畅的沉浸式追更。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className="card-lift rounded-lg border border-background-300/50 bg-background-100 p-5 md:p-6"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-500/15 text-primary-400">
                <i className={`${f.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-50">{f.title}</h3>
              <p className="mt-2 text-xs leading-6 text-foreground-300 md:text-sm md:leading-7">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}